// extracted by mini-css-extract-plugin
export default {"icon":"Dokl","title":"mWyT","text":"_21SF","button":"_17mP"};